/* unplugin-vue-components disabled */import script from "./MaskerLayer.vue?vue&type=script&setup=true&lang=js"
export * from "./MaskerLayer.vue?vue&type=script&setup=true&lang=js"

import "./MaskerLayer.vue?vue&type=style&index=0&id=056e7746&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-056e7746"]])

export default __exports__